import * as z from "zod/v4";

export const createLinearIssue = {
  name: "createLinearIssue" as const,
  input: z.object({
    title: z.string().min(1),
    description: z.string().optional(),
    teamId: z.string(),
    stateId: z.string().optional(),
    priority: z.number().int().min(0).max(4).optional(),
    assigneeId: z.string().optional(),
    labelIds: z.array(z.string()).optional(),
    projectId: z.string().optional(),
  }),
  output: z.object({
    success: z.boolean(),
    issueId: z.string().nullable(),
    issueIdentifier: z.string().nullable().optional(),
    issueUrl: z.string().nullable().optional(),
    error: z.string().nullable().optional(),
  }),
};
